<template>
    <div class="developer-hub">
        <PageHeader :title="$t('developer.hub.title')" :subtitle="$t('developer.hub.subtitle')"/>
        <CheckerboardContainer>
            <CheckerboardItem
                v-for="(item, i) in allowedSections"
                :key="i"
                :title="$t(item.title)"
                :subtitle="item.subtitle ? $t(item.subtitle) : undefined"
                title-size="s"
                :route="{ name: item.route }"
                :image="item.image"
                :icon="item.icon"
            />
        </CheckerboardContainer>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageHeader from '@/components/ui/page/PageHeader';
import CheckerboardContainer from '@/components/ui/checkerboard/Checkerboard';
import CheckerboardItem from '@/components/ui/checkerboard/CheckerboardItem';

export default {
    name: 'DeveloperHubPage',
    components: { PageHeader, CheckerboardContainer, CheckerboardItem },
    data() {
        return {
            sections: [
                {
                    title: 'developer.exports-surveillance.title',
                    subtitle: 'developer.exports-surveillance.subtitle',
                    image: '/img/goldenmetrics/box-arrow-down.svg',
                    route: 'exports-status',
                },
                {
                    title: 'developer.mcp-connector.title',
                    subtitle: 'developer.mcp-connector.subtitle',
                    icon: 'collaboration',
                    route: 'developer-mcp-connector',
                    roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                },
            ],
        };
    },
    computed: {
        ...mapGetters(['roleIsAllowed']),
        allowedSections() {
            return this.sections.filter((item) => {
                if (!item.roles) {
                    return true;
                }
                return this.roleIsAllowed(item.roles);
            });
        },
    },
};
</script>
